let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ilQK3")).then(() => parcelRequire('hOArl'));